<div
  class="main-container"
  *ngIf="showNotification && !dismissIncomingCall && !isCallAccepted"
>
  <!-- <div class="main-container"> -->
  <div class="incoming-call">
    <div class="info">
      <div class="avatar" aria-hidden="true">{{ initials }}</div>
      <div
        class="meta"
        role="button"
        tabindex="0"
        [attr.aria-pressed]="isSwapped"
        [attr.title]="data.name"
      >
        <div class="stack" [class.swapped]="isSwapped">
          <div class="line top">{{ data.name }}</div>
          <div class="line bottom">{{ formatDisplayNumber(data.number) }}</div>
        </div>
        <div class="clinic">{{ data.clinic }}</div>
      </div>
    </div>
  </div>

  <div class="clinic" style="align-content: center">{{ runningCallTimer }}</div>

  <div class="btn-group">
    <!-- <div class="circle-btn">
      <svg
        width="22"
        height="24"
        viewBox="0 0 22 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="idkIcon"
      >
        <path
          d="M14.1124 17.3685L12.4115 17.6222C12.0038 17.6822 11.6454 17.926 11.4401 18.2816L10.5651 19.7972C8.47491 19.3521 6.56546 18.2574 5.13244 16.6606L6.01081 15.1392C6.21609 14.7837 6.24807 14.3514 6.09617 13.9683L5.46792 12.3776C5.21362 11.7412 4.52892 11.3925 3.86692 11.5699L2.74521 11.8704C2.00965 12.0675 1.56206 12.8428 1.80512 13.566C3.63671 19.0224 9.26754 22.2734 14.9087 21.1314C15.6566 20.9803 16.1042 20.205 15.9071 19.4695L15.6066 18.3478C15.435 17.6891 14.7907 17.2705 14.1124 17.3685Z"
          fill="white"
        />
        <path
          d="M13.5999 0C9.35949 0 5.92188 3.43762 5.92188 7.67806C5.92188 11.9185 9.35949 15.3561 13.5999 15.3561C17.8404 15.3561 21.278 11.9185 21.278 7.67806C21.278 3.43762 17.8404 0 13.5999 0ZM9.73666 6.06163H8.48123V5.25341H11.5282C11.5282 5.25341 11.5794 5.59286 11.5794 5.79222C11.5794 6.31218 11.1564 6.73514 10.6365 6.73514C10.2108 6.73514 9.8525 6.44957 9.73666 6.06163ZM15.871 10.426C14.2519 10.135 12.657 10.4529 11.4932 11.2935L11.019 10.6388C12.358 9.66897 14.1792 9.30258 16.0111 9.63125L15.871 10.426ZM17.641 6.73514C17.2154 6.73514 16.8571 6.44957 16.7412 6.06163H15.4858V5.25341H18.5328C18.5328 5.25341 18.5839 5.59286 18.5839 5.79222C18.5839 6.31218 18.161 6.73514 17.641 6.73514Z"
          fill="white"
        />
      </svg>
    </div> -->

    <div class="circle-btn halo call" (click)="onClick($event)">
      <i class="ti ti-phone"></i>
    </div>

    <div class="circle-btn end" (click)="onEndCall($event)">
      <svg
        width="18"
        height="17"
        viewBox="0 0 18 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_11253_10930)">
          <path
            d="M3.95909 10.5546L5.32273 9.47047C5.65 9.21138 5.84091 8.81592 5.84091 8.40001V6.62729C7.9 5.9591 10.1295 5.95229 12.1955 6.62729V8.40683C12.1955 8.82274 12.3864 9.21819 12.7136 9.47728L14.0705 10.5546C14.6159 10.9841 15.3932 10.9432 15.8841 10.4523L16.7159 9.62047C17.2614 9.07501 17.2614 8.16819 16.6818 7.65683C12.3114 3.79774 5.725 3.79774 1.35454 7.65683C0.774999 8.16819 0.774999 9.07501 1.32045 9.62047L2.15227 10.4523C2.63636 10.9432 3.41364 10.9841 3.95909 10.5546V10.5546Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_11253_10930">
            <rect
              width="16.3636"
              height="16.3636"
              fill="white"
              transform="translate(0.884277)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  </div>
</div>

<div
  class="main-container"
  *ngIf="showOngoingCallCard && ongoingCallData"
  #ongoingCallContainer
>
  <!-- <div class="main-container"> -->
  <div class="incoming-call">
    <div class="info">
      <div class="avatar" aria-hidden="true">
        {{ getInitials(ongoingCallData.name || "") }}
      </div>
      <div
        class="meta"
        role="button"
        tabindex="0"
        [attr.aria-pressed]="isSwapped"
        [attr.title]="ongoingCallData.name"
      >
        <div class="stack" [class.swapped]="isSwapped">
          <div class="line top">{{ ongoingCallData.name }}</div>
          <div class="line bottom">
            {{ formatDisplayNumber(ongoingCallData.number) }}
          </div>
        </div>
        <div class="clinic">{{ ongoingCallData.clinic }}</div>
      </div>
    </div>
  </div>

  <div class="clinic" style="align-content: center">
    {{ formatCallDuration(callDuration) }}
  </div>

  <div class="btn-group">
    <div class="circle-btn end" (click)="onEndOngoingCall($event)">
      <svg
        width="18"
        height="17"
        viewBox="0 0 18 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_11253_10930)">
          <path
            d="M3.95909 10.5546L5.32273 9.47047C5.65 9.21138 5.84091 8.81592 5.84091 8.40001V6.62729C7.9 5.9591 10.1295 5.95229 12.1955 6.62729V8.40683C12.1955 8.82274 12.3864 9.21819 12.7136 9.47728L14.0705 10.5546C14.6159 10.9841 15.3932 10.9432 15.8841 10.4523L16.7159 9.62047C17.2614 9.07501 17.2614 8.16819 16.6818 7.65683C12.3114 3.79774 5.725 3.79774 1.35454 7.65683C0.774999 8.16819 0.774999 9.07501 1.32045 9.62047L2.15227 10.4523C2.63636 10.9432 3.41364 10.9841 3.95909 10.5546V10.5546Z"
            fill="white"
          />
        </g>
        <defs>
          <clipPath id="clip0_11253_10930">
            <rect
              width="16.3636"
              height="16.3636"
              fill="white"
              transform="translate(0.884277)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>

    <div class="circle-btn halo call" (click)="openCallDetail($event)">
      <i class="ti ti-chevron-down"></i>
    </div>
  </div>
</div>

<ng-template
  #callModal
  let-modal
  class="modal fade"
  id="callModal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
  <app-incoming-call-modal
    (modalDismiss)="handleModalDismiss()"
    (onEnd)="onEndOngoingCall($event)"
    (onStartNextCall)="onStartNextCall($event)"
    (queueListUpdated)="onQueueListUpdated($event)"
    [data]="data"
    [conferenceId]="conferenceId"
    [sid]="callSid"
    [fromNumber]="fromNumber"
    [newIncomingCall]="latestIncomingCall"
    [callDuration]="callDuration"
    [programId]="summaryProgramId"
    [interactionTypeId]="summaryInteractionTypeId"
    [patientId]="summaryPatientId"
    [confSid]="summaryConfSid"
    [summarySaved]="summarySaved"
  />
</ng-template>

<ng-template
  #generatedSummaryModal
  let-modal
  class="modal fade summary-modal"
  id="generatedSummaryModal"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
>
  <div class="modal-header">
    <h4 class="modal-title text-center" id="myCenterModalLabel">
      Generated Summary
    </h4>
    <button
      type="button"
      class="btn-close"
      (click)="cancelSummaryModal()"
      aria-label="Close"
    ></button>
  </div>
  <div class="modal-body">
    <app-select
      class="w-100"
      label="Program"
      [showLabel]="true"
      [items]="programOptions"
      [formGroup]="generatedSummaryForm"
      formControlValue="programId"
      [isRequired]="true"
    />
    <app-select
      class="w-100"
      label="Interaction Type"
      [showLabel]="true"
      [items]="interactionTypeOptions"
      [formGroup]="generatedSummaryForm"
      formControlValue="interactionTypeId"
      [isRequired]="true"
    />
    <app-text-area
      class="w-100"
      [formGroup]="generatedSummaryForm"
      formName="generatedSummary"
      [formControlValue]="'generatedSummary'"
      [showLabel]="false"
      [rows]="15"
    />
  </div>
  <div class="modal-footer">
    <button
      class="btn"
      type="button"
      (click)="cancelSummaryModal()"
      style="background-color: #d6d6d6; color: #5b5b5b; border: 0"
    >
      Cancel
    </button>
    <button
      class="btn btn-primary"
      type="button"
      [disabled]="generatedSummaryForm.invalid"
      (click)="saveGeneratedSummary()"
    >
      Save
    </button>
  </div>
</ng-template>
